import { SimpleForm, Edit, useInput, SelectInput, TextInput } from 'react-admin'
import ReactJson from '@microlink/react-json-view'

const JsonInput = (props) => {
  const {
    field: { name, onChange, value },
  } = useInput(props)

  return (
    <ReactJson
      src={value || {}}
      name={name}
      onEdit={(edit) => {
        onChange(edit.updated_src)
      }}
      onDelete={(del) => {
        onChange(del.updated_src)
      }}
      onAdd={(add) => {
        onChange(add.updated_src)
      }}
      displayDataTypes={false}
    />
  )
}
const ImportLogEdit = (props) => {
  return (
    <Edit title="Upload Import Log" {...props}>
      <SimpleForm>
        <JsonInput source="column_mapping" label="Column Mapping" />
        <SelectInput
          label="Import Type"
          source="import_type"
          choices={[
            { id: 1, name: 'Vendor / tag import' },
            { id: 2, name: 'Transaction / spend import' },
            { id: 3, name: 'Companies House import' },
          ]}
        />
        <TextInput label="Date Format" source="date_format" />
      </SimpleForm>
    </Edit>
  )
}

export default ImportLogEdit
